module.exports = __webpack_public_path__ + "static/screenshot4-0c49baaf33155bcff983a0b6b532d98f.jpg";